import { call, cancel, fork, take } from 'redux-saga/effects';

import { CONNECT_FULFILLING } from './druid/./druid/actions/connect';
import { DISCONNECT_PENDING } from './druid/./druid/actions/disconnect';
import { RECONNECT_PENDING, RECONNECT_FULFILLING } from './druid/./druid/actions/reconnect';

import type { DirectLineJSBotConnection } from './druid/./druid/types/external/DirectLineJSBotConnection';

export default function whileConnectedEffect<P extends any[]>(
  fn: (
    {
      directLine,
      userID,
      username
    }: {
      directLine: DirectLineJSBotConnection;
      userID: string;
      username: string;
    },
    ...args: P
  ) => void,
  ...args: P
) {
  return call(function* whileConnected() {
    for (;;) {
      const {
        meta: { userID, username },
        payload: { directLine }
      }: {
        meta: {
          userID: string;
          username: string;
        };
        payload: { directLine: DirectLineJSBotConnection };
      } = yield take([CONNECT_FULFILLING, RECONNECT_FULFILLING]);

      const task = yield fork(fn, { directLine, userID, username }, ...args);

      // When we receive DISCONNECT_PENDING or RECONNECT_PENDING, the Direct Line connection is currently busy and should not be used.

      yield take([DISCONNECT_PENDING, RECONNECT_PENDING]);
      yield cancel(task);
    }
  });
}
